// extracted by mini-css-extract-plugin
export default {"container":"tooltip-provider_container__Lq6tA","truncate-table":"tooltip-provider_truncate-table__ivOk6","table-text-faded":"tooltip-provider_table-text-faded__heucJ","tooltip":"tooltip-provider_tooltip__UjsGU"};
    if(module.hot) {
      // 1793877074214
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  